import { create } from 'zustand';

interface NewVersionState {
  /** The version this page loaded with, from `image_tag`: `0.2.886` in `13f748d0…-v0.2.886-dev`. */
  runningVersion?: string;
  /** The version the server runs, while it differs from `runningVersion`. The top bar then offers a
      reload. Both are set by `watchForNewVersion()` (`src/utils/newVersion.ts`). */
  newVersion?: string;
}

/** Not persisted: the reload that loads the new build starts again without a new version. */
export const useNewVersionStore = create<NewVersionState>(() => ({}));
